import React, { Component } from "react";
import Button from "material-ui/Button";
import { withRouter } from "react-router";
import { withStyles } from "material-ui/styles";
import Container from "../controls/Container";
import Searchbox from "../controls/Searchbox";
import Message from "../controls/Message";
import ApiAutoFetchDatagrid from "../controls/datagrid/ApiAutoFetchDatagrid";
import api from "../../api";
import CircularLoader from "../controls/loader/CircularLoader";
import YesNo from "../controls/dialog/YesNo";

const styles = theme => ({
  leftIcon: {
    marginRight: theme.spacing.unit
  },
  button: {
    margin: theme.spacing.unit
  },
  iconSmall: {
    fontSize: 20
  },
  wrapper: {
    position: "relative",
    margin: "20px 5px 5px 5px"
  }
});

class Vendors extends Component {
  vendorColumns = ["Id", "Name", "Description", "Address", "Mobile", "Email"];

  state = {
    clearSearch: false,
    serachQuery: "",
    message: "",
    showMessage: false,
    isError: false,
    isLoading: false,
    showConfirmDeleteDialog: false
  };

  onListClick = () => {
    this.setState({ clearSearch: true, serachQuery: "", showMessage: false });
  };

  onSearchSubmit = async id => {
    this.setState({ clearSearch: false, serachQuery: id });
  };

  onCreateNewClick = () => {
    this.props.history.push("Vendors/new");
  };

  onEdit = row => {
    this.props.history.push(`Vendors/edit/${row.id}`);
  };

  onDelete = itemToDelete => {
    this.setState({ showConfirmDeleteDialog: true, itemToDelete });
  };

  onConfirmDeleteClick = async () => {
    const { id } = this.state.itemToDelete;

    try {
      this.setState({ isLoading: true });

      const res = await api.vendor.delete(id);

      if (res.status === 200) {
        this.showMessage("Deleted successfully.");
      } else {
        throw new Error(
          `Couldn't delete the record. The status code is ${res.status}`
        );
      }
    } catch (error) {
      this.showMessage(error.message, true);
    }
  };

  showMessage = (message, isError = false) => {
    this.setState({
      showMessage: true,
      isError,
      message,
      isLoading: false,
      showConfirmDeleteDialog: false
    });
  };

  onMessageCloseClick = () => {
    this.setState({ showMessage: false });
  };

  onCancelConfirmDeleteClick = () => {
    this.setState({ showConfirmDeleteDialog: false });
  };

  getApiPromise = () => {
    const { serachQuery } = this.state;

    if (serachQuery.length === 0) {
      return api.vendor.fetchByPages();
    }

    return api.vendor.searchByIdAndGetByPages(serachQuery);
  };

  render() {
    const { classes } = this.props;
    const {
      clearSearch,
      message,
      showMessage,
      isError,
      isLoading,
      showConfirmDeleteDialog
    } = this.state;

    return (
      <Container title="Vendors">
        <CircularLoader isLoading={isLoading} />
        <YesNo
          open={showConfirmDeleteDialog}
          message="Are you sure wan't to delete the selected item"
          onOk={this.onConfirmDeleteClick}
          onCancel={this.onCancelConfirmDeleteClick}
        />

        <div>
          <Button
            className={classes.button}
            variant="raised"
            color="default"
            size="small"
            onClick={this.onListClick}
          >
            List
          </Button>

          <Button
            className={classes.button}
            variant="raised"
            color="primary"
            size="small"
            onClick={this.onCreateNewClick}
          >
            Create New
          </Button>

          <Searchbox
            clear={clearSearch}
            onChange={this.onSearchChange}
            onSubmit={this.onSearchSubmit}
          />
        </div>

        <Message
          style={{ width: "98%" }}
          title="Message"
          message={message}
          show={showMessage}
          isError={isError}
          onCloseClick={this.onMessageCloseClick}
          autoClose={!isError}
        />
        <div className={classes.wrapper}>
          {/* <ApiAutoFetchDatagrid
            datasourcePromise={this.getApiPromise}
            actions={["del", "edit"]}
            onEdit={this.onEdit}
            onDelete={this.onDelete}
            headers={this.vendorColumns}
          /> */}
          <table className="customtable">
            <thead className="customthead">
            <tr className="customtr">
              <th>Id</th>
              <th>Name</th>
              <th>Description</th>
              <th>Address</th>
              <th>Mobile</th>
              <th>Email</th>
              <th>Actions</th>
            </tr>
            </thead>
            <tr className="customtr">
              <td>2918</td>
              <td>ANDREW EPSTEIN</td>
			  <td>Vendor for machines</td>
              <td>12, Jln Sri Damak 18 Kaw 2 Taman Sri Andalas, 41200, Klang.</td>
              <td>012-3892746</td>
              <td>aeps@gmail.com</td>
            </tr>
            <tr className="customtr">
              <td>1294</td>
              <td>BARBARA RAMIREZ</td>
			  <td>Vendor for trucks</td>
              <td>3, Jalan Singa B 20/B Seksyen 20, 40300, Shah Alam.</td>
              <td>018-20394857</td>
              <td>barbara_r@gmail.com</td>
            </tr>
            <tr className="customtr">
              <td>3940</td>
              <td>FREDERICK BENJAMIN</td>
			  <td>Vendor for billing</td>
              <td>28, Jln Bola Tampar 13/14 Seksyen 13, 40300, Shah Alam.</td>
              <td>016-3955922</td>
              <td>fred_ben@gmail.com</td>
            </tr>
            <tr className="customtr">
              <td>3216</td>
              <td>GEORGES VOLTAIRE</td>
			  <td>Vendor for software services</td>
              <td>32, Jln Batu Arang Batu 23 Sungai Bakau, 48000, Rawang.</td>
              <td>013-2094867</td>
              <td>gvoltair@gmail.com</td>
            </tr>
            <tr className="customtr">
              <td>1124</td>
              <td>PERRY GREENBERG</td>
			  <td>Vendor for cleaning</td>
              <td>43, Jalan Bk 5/11, Bandar Kinrara, 47100, Puchong</td>
              <td>012-3048576</td>
              <td>pgreenberg@gmail.com</td>
            </tr>
          </table>
        </div>
      </Container>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(Vendors));



// WEBPACK FOOTER //
// ./src/components/vendor/Vendors.js